import { AspectRatio, Box, HStack, Icon, Image, Text } from '@chakra-ui/react';
import { getAssetUrl } from '@cronos-app/chakra';
import { ChevronRight } from '@cronos-app/icons';
import { useCdcCardView } from '@ui/views/card-cronos/core/utils';
import { useTranslations } from 'next-intl';

import { CardView } from '../../core/types';

export const SharedHeader = () => {
  const t = useTranslations();
  const { view, setView } = useCdcCardView();
  return (
    <Box pos="relative" w="full" mb="4">
      {view === CardView.First && (
        <AspectRatio w="full" ratio={648 / 426}>
          <Image
            src={getAssetUrl('/images/defi-wallet-shadow.png')}
            w="full"
            alt="DeFi Wallet"
          />
        </AspectRatio>
      )}
      {view === CardView.Second && (
        <HStack
          gap={1}
          cursor="pointer"
          onClick={() => setView(CardView.First)}
          pos="absolute"
          bottom="8px"
        >
          <Icon
            as={ChevronRight}
            boxSize="6"
            color="white"
            transform="rotate(180deg)"
          />
          <Text textStyle="overline" textTransform="uppercase">
            {t('card.back')}
          </Text>
        </HStack>
      )}
    </Box>
  );
};
